import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_NOTIFY_ME,
   DELETE_NOTIFY_ME,
   GET_NOTIFICATION,
   GET_NOTIFY_ME,
   READ_NOTIFICATION,
   UPDATE_NOTIFY_ME,
   UPDATE_NOTIFY_ME_STATUS,
} from '../types';
import { setAlert } from './alert';

export const getNotifyMe = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/notify/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_NOTIFY_ME, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
export const addNotifyMe = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/notify/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_NOTIFY_ME, payload: res.data.data });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return { success: true, data: res.data.data }; // Return success
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return { success: false, message: res.data.message }; // Return failure
      }
   } catch (err) {
      console.log('Error response:', err.response);

      const errorMessage =
         err.response?.data?.message || err.response?.data?.errors?.[0]?.message || 'Something went wrong!';

      toast.error(errorMessage);
      throw new Error(errorMessage); // Throw error
   }
};

export const updateNotifyMe = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/notify/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_NOTIFY_ME, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateNotifyMeStatus = (data) => async (dispatch) => {
   try {
      const response = await axios.post('/notify/update/status', {
         id: data.id,
         status: data.status,
      });

      if (response.data.code === 1) {
         toast.success('User status updated successfully');
         dispatch({
            type: UPDATE_NOTIFY_ME_STATUS,
            payload: {
               id: data.id,
               status: data.status,
            },
         });
         return true;
      } else {
         toast.error('Failed to update user status');
         return false;
      }
   } catch (error) {
      if (error.response) {
         const { status, data } = error.response;
         if (status === 404) {
            toast.error('User not found');
         } else if (status === 400) {
            toast.error(data.message || 'Bad Request');
         } else {
            toast.error(data.message || 'An unknown error occurred');
         }
      } else {
         toast.error('A network error occurred');
      }
      return false;
   }
};

export const deleteNotifyMe = (id) => async (dispatch) => {
   try {
      if (!id) {
         dispatch(setAlert('Please select any record', 'warning'));
         return false;
      }
      const res = await axios.post(`/notify/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_NOTIFY_ME, payload: { id } });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getNotification = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/notification/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_NOTIFICATION,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const ReadNotification = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/notification/read', { params });

      if (res.data.code === 1) {
         dispatch({ type: READ_NOTIFICATION, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
